<template>
  <li class="item">
    <button type="button" class="btn-trigger" data-popup-open="#video_popup">
      <div class="thumb">
        <div class="thumb-img">
          <img :src="thumbnailSrc" alt="" />
        </div>
        <div class="thumb-over" @click="() => emits('requestPlay', props.link)">
          <i class="c-icon icon-play"></i>
          <span class="sr-only">재생</span>
        </div>
      </div>
      <div class="text-wrap">
        <strong class="subject"> {{ props.link.titleNm }} </strong>
        <p class="text">
          {{ props.link.memoCn }}
        </p>
      </div>
    </button>
  </li>
</template>
<script setup>
import { onMounted, defineProps, ref, defineEmits } from "vue";
import noImage from "@/assets/images/common/img_no_product.svg";
import axios from "axios";
import axiosJsonp from "axios-jsonp";

const emits = defineEmits(["requestPlay"]);

const props = defineProps({
  link: {
    type: Object,
    required: true,
  },
});

const thumbnailSrc = ref(noImage);

onMounted(() => {
  setThumbnailSrc();
});

const setThumbnailSrc = () => {
  if (props.link.linkUrlSeCd === "V") {
    setVimeoThumbnail();
  } else if (props.link.linkUrlSeCd === "U") {
    setYoutubeThumbnail();
  }
};

const setYoutubeThumbnail = async () => {
  const regx = /youtu\.be\/(\w+)/;

  const match = props.link.linkUrl.match(regx);
  const videoId = match[1];

  thumbnailSrc.value = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
};

const setVimeoThumbnail = async () => {
  const regx = /vimeo\.com\/(\d+)/;

  try {
    const match = props.link.linkUrl.match(regx);
    const videoId = match[1];

    const response = await axios.get(
      `http://vimeo.com/api/v2/video/${videoId}.json`,
      { adapter: axiosJsonp }
    );

    thumbnailSrc.value = response.data[0].thumbnail_large;
  } catch (error) {
    console.error("Failed to get thumbnail", error);
  }
};
</script>
